import { render, staticRenderFns } from "./orderChargesInfo.vue?vue&type=template&id=304e2284&"
import script from "./orderChargesInfo.vue?vue&type=script&lang=js&"
export * from "./orderChargesInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports